
export const CALLBACK_ENUM = {
  FULL_SCREEN: 'fullscreen' // 全屏
}

export function makeMessage(type, code, data) {
  return {type, code, data}
}